<template>
<div
    class="skill rectangle flex items-center justify-center lg:justify-start mx-auto"
    :class="{
        skill__locked: !trophy.unlocked,
        medium: isMedium,
        high: isHigh, }"
>
    <div class="content lg:flex lg:items-center"
    :class="{
        'text-center': trophy.icon === undefined
    }">
        <img :src="trophy.icon.url" alt="" class="lg:mr-2" v-if="trophy.icon !== undefined"/>
        <p v-html="trophy.text.replace(/\n/g, '<br />')" />
    </div>
</div>
</template>

<script>
export default {
    props: {
        isMedium: {
            type: Boolean,
            required: false
        },
        isHigh: {
            type: Boolean,
            required: false
        },
        trophy: {
            type: Object,
            required: true
        }
    }
}
</script>